module.exports = __webpack_public_path__ + "static/img/sj.423c0247.svg";